/** Session and identity errors — ERR-identity.* aliases and ERR-AUTH session codes. */

const FORCE_SIGN_IN_CODES = new Set([
  'ERR-identity.session-expired',
  'ERR-identity.invalid-credentials',
  'ERR-identity.refresh-reused',
  'ERR-AUTH-0010',
  'ERR-AUTH-0011',
  'ERR-AUTH-0012',
  'ERR-AUTH-0021',
  'ERR-AUTH-0022',
  'ERR-AUTH-0023',
  'ERR-AUTH-0064',
]);

const REFRESH_FIRST_CODES = new Set(['ERR-AUTH-0011', 'ERR-identity.session-expired']);
type SessionErrorListener = (code: string) => void;
const sessionErrorListeners = new Set<SessionErrorListener>();

export function isIdentitySessionError(code: string | undefined): boolean {
  if (!code) return false;
  if (code.startsWith('ERR-identity.')) return true;
  return FORCE_SIGN_IN_CODES.has(code);
}

export function shouldAttemptTokenRefresh(code: string | undefined): boolean {
  if (!code) return false;
  return REFRESH_FIRST_CODES.has(code);
}

export function shouldForceSignIn(code: string | undefined): boolean {
  if (!code) return false;
  if (code.startsWith('ERR-identity.')) {
    return !shouldAttemptTokenRefresh(code);
  }
  return FORCE_SIGN_IN_CODES.has(code);
}

export function notifySessionError(code: string | undefined): void {
  if (!isIdentitySessionError(code) || !code) return;
  for (const listener of sessionErrorListeners) listener(code);
}

export function subscribeSessionErrors(listener: SessionErrorListener): () => void {
  sessionErrorListeners.add(listener);
  return () => sessionErrorListeners.delete(listener);
}
